export function convertYearToMonthPrice(price: number) {
  // 100 - to get correct rounding for 2 digits
  return Math.round((price * 100) / 12) / 100;
}
